import { Component } from 'preact';

export default class Default extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <style dangerouslySetInnerHTML={{
                __html: `
                :root {
                     /* Global */
                    --brand-global-radius: 20px;

                    /* Colors */
                    --brand-color-background: #FFF;
                    --brand-color-secondary: #e9e9ef;
                    --brand-color-border: #282364;
                    --brand-color-body: #222;
                    --brand-color-primary: #BF352D;
                    --brand-color-focus: #008000;

                    /* Fonts */
                    --brand-font-family-title: "Quicksand", sans-serif;
                    --brand-font-family-body: "Quicksand", sans-serif;
                    --brand-font-weight-regular: 400;
                    --brand-font-weight-bold: 700;

                    /* Title */
                    --brand-title-weight: 700;
                    --brand-title-transform: uppercase;
                    --brand-title-spacing: 0;

                    /* Input */
                    --brand-input-border-width: 1px;
                    --brand-input-border-color: #282364;

                    /* Button */
                    --brand-button-radius: 20px;
                    --brand-button-border-size: 0;
                    --brand-button-border-color: transparent;
                    --brand-button-font-color: #FFF;
                    --brand-button-font-size: 14px;
                    --brand-button-font-weight: 400;
                    --brand-button-font-transform: uppercase;
                    --brand-button-font-spacing: 1px;
                  }
            `
            }}></style>

        );
    }
}
